function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2 347.244L94.9849 219.036C97.2724 215.882 101.567 214.955 104.952 216.883L222.492 283.846C226.119 285.912 230.733 284.685 232.855 281.09L328.376 119.194C330.508 115.581 335.154 114.363 338.784 116.464L454.063 183.198C457.519 185.199 461.934 184.2 464.192 180.906L571.641 24.1875",
  stroke: "url(#paint0_linear_8812_12593)",
  strokeWidth: 3.27454,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M513.118 46.5069L572.033 20.9197C573.024 20.4893 574.122 21.2508 574.066 22.3297L570.751 86.475",
  stroke: "url(#paint1_linear_8812_12593)",
  strokeWidth: 3.27454,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_8812_12593",
  x1: 519.828,
  y1: 101.36,
  x2: 75.7784,
  y2: 429.57,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F034A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F034A6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_8812_12593",
  x1: 574.187,
  y1: 19.9841,
  x2: 541.935,
  y2: 66.4909,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F034A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F034A6",
  stopOpacity: 0
})));

function SvgSpikeArrow(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 603,
    height: 349,
    viewBox: "0 0 603 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpikeArrow);
export default __webpack_public_path__ + "static/media/spike-arrow.cfe4e455811a40042d0571e5866bbef9.svg";
export { ForwardRef as ReactComponent };